import { useState, useCallback } from 'react';
import { IoLogoWhatsapp } from 'react-icons/io5';

const CONTACT_NUMBER = '+918062689355';
const PRE_FILLED_MESSAGE = 'I am Interested';

const WhatsAppChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleChat = useCallback((platform) => {
    const encodedMessage = encodeURIComponent(PRE_FILLED_MESSAGE);
    const url = `https://wa.me/${CONTACT_NUMBER}?text=${encodedMessage}`;

    window.open(url, '_blank');

    setIsOpen(false);

  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div 
          className="absolute bottom-16 right-0 w-64 bg-white shadow-[0_0_14px_1px_#020101] rounded-xl overflow-hidden transform transition-all duration-300 ease-in-out border border-gray-100 
                     sm:w-72"
        >
          <div className="py-5 px-4 bg-white text-black rounded-t-xl border-b border-gray-200">
            <h3 className="font-[500] text-center text-lg">Chat with Support</h3>
          </div>

          <div className="p-4 space-y-2 flex items-center justify-center">
            <button onClick={handleChat} className='bg-green-600 flex items-center gap-x-1.5 hover:bg-green-500 text-white text-center rounded-full px-3 py-1.5 text-[14.5px]'>
                <IoLogoWhatsapp className='text-xl' />
                <span>Chat on WhatsApp</span>
            </button>
          </div>
          
          <div className="p-3 text-center text-xs text-gray-700 border-t">
            Chatting with: <span className="font-mono text-gray-700">{`+91 ${CONTACT_NUMBER}`}</span>
          </div>

        </div>
      )}

      <button
        onClick={handleChat}
        aria-label="Toggle WhatsApp Chat"
        className="w-14 h-14 rounded-full bg-green-500 text-white shadow-xl 
                   flex items-center justify-center cursor-pointer 
                   hover:bg-green-600 transition-transform duration-200 transform hover:scale-105
                   focus:outline-none focus:ring-4 focus:ring-green-300"
      >
        <IoLogoWhatsapp className="w-8 h-8" />
      </button>
    </div>
  );
};
export default WhatsAppChatWidget;